

export default function getVariables(env: any) : any {
	return {
		"aws_account_id": env.VUE_APP_aws_account_id,
		"aws_appsync_graphqlEndpoint": env.VUE_APP_aws_appsync_graphqlEndpoint,
		"aws_rest_api_endpoint": env.VUE_APP_aws_rest_api_endpoint,
		"aws_user_files_s3_bucket_region": env.VUE_APP_aws_user_files_s3_bucket_region,
		"aws_user_pools_id": env.VUE_APP_aws_user_pools_id,
		"aws_user_pools_web_client_id": env.VUE_APP_aws_user_pools_web_client_id,
		"aws_cognito_identity_pool_id": env.VUE_APP_aws_cognito_identity_pool_id,
		"aws_user_files_s3_bucket": env.VUE_APP_aws_user_files_s3_bucket,
		"aws_user_thumbs_s3_bucket": env.VUE_APP_aws_user_thumbs_s3_bucket,
		"aws_org_logos_s3_bucket": env.VUE_APP_aws_org_logos_s3_bucket,
		"aws_appsync_authenticationType": env.VUE_APP_aws_appsync_authenticationType,
		"aws_project_region": env.VUE_APP_aws_project_region,
		"aws_cognito_region": env.VUE_APP_aws_project_region,
		"aws_appsync_region": env.VUE_APP_aws_project_region,
		"aws_cloudfront_hosting_oai_id": env.VUE_APP_aws_cloudfront_hosting_oai_id,
		"aws_cloudfront_files_key_id": env.VUE_APP_aws_cloudfront_files_key_id,
		"aws_cloudfront_files_domain": env.VUE_APP_aws_cloudfront_files_domain,
		"aws_cloudfront_thumbnails_domain": env.VUE_APP_aws_cloudfront_thumbnails_domain,
		"aws_cloudfront_logos_domain": env.VUE_APP_aws_cloudfront_logos_domain,
		"hosting_url": env.VUE_APP_hosting_url,
		"stripe_annual_starter": env.VUE_APP_stripe_annual_starter,
		"stripe_annual_professional": env.VUE_APP_stripe_annual_professional,
		"stripe_annual_large_firm": env.VUE_APP_stripe_annual_large_firm,
		"stripe_annual_enterprise": env.VUE_APP_stripe_annual_enterprise,
		"stripe_month_starter": env.VUE_APP_stripe_month_starter,
		"stripe_month_professional": env.VUE_APP_stripe_month_professional,
		"stripe_month_large_firm": env.VUE_APP_stripe_month_large_firm,
		"stripe_month_enterprise": env.VUE_APP_stripe_month_enterprise,
		"stripe_public_key": env.VUE_APP_stripe_public_key,
		"stripe_professional_product_id": env.VUE_APP_stripe_professional_product_id,
		"stripe_large_firm_product_id": env.VUE_APP_stripe_large_firm_product_id,
		"stripe_enterprise_product_id": env.VUE_APP_stripe_enterprise_product_id,
		// Platform OAuth configuration (Zapier integration).
		// SECURITY: jwt_secret and zapier_client_secret are intentionally NOT exported here.
		// They are server-only and are injected into the CDK build from process.env in
		// cf-support-lib.buildCloudFormationStacks so they never reach the browser bundle.
		"zapier_client_id": env.VUE_APP_zapier_client_id,
		"zapier_redirect_uri": env.VUE_APP_zapier_redirect_uri,
		// API Gateway custom domain (hosted zone is looked up automatically from domain)
		"api_domain": env.VUE_APP_api_domain,
		"api_certificate_arn": env.VUE_APP_api_certificate_arn,
		// Twilio TURN (SIDs only - the API key secret lives in Secrets Manager).
		// Used by CDK to substitute {{twilio_account_sid}} / {{twilio_api_key_sid}}
		// in lambda/getTwilioToken/parameters.json
		"twilio_account_sid": env.VUE_APP_twilio_account_sid,
		"twilio_api_key_sid": env.VUE_APP_twilio_api_key_sid
	};
};

//TODO: Generate aws-exports from cf-web-stack and overwrite js file. Deploy vue build last.
